// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"652":"service","962":"home"}[chunkId] + "." + {"652":"8f57248f","962":"c64c9ceb"}[chunkId] + ".js";
};